import script from "./ModalBottomComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBottomComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModalBottomComponent.vue?vue&type=style&index=0&id=1b444ba1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b444ba1"]])

export default __exports__